import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class OrderEndpoints {
  constructor(private http: HttpClient) {}
}
